import { Briefcase } from "lucide-react";

export function EmptyJobsState() {
  return (
    <div className="text-center py-12">
      <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
        {/* //TODO: Add a different icon here */}
        <Briefcase className="h-10 w-10 text-orange-500" />
      </div>
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        No jobs available right now
      </h4>
      <p className="text-gray-500 max-w-sm mx-auto">
        New opportunities are added regularly. Check back soon or get notified when new jobs match your interests!
      </p>
    </div>
  );
}
